<template>
  <div>
    <van-form class="form">
      <!-- <van-field
        v-model="form.goodsName"
        label="商品名称"
        placeholder="请输入商品名称"
        right-icon="clear"
        @click-right-icon="form.goodsName = ''"
      /> -->
      <van-field
        readonly
        clickable
        right-icon="clear"
        v-model="form.orderStartTime"
        label="订单开始时间"
        placeholder="请选择订单开始时间"
        @click="openStartTimePicker"
        @click-right-icon.stop="clearOrderStartTime"
      />
      <van-popup v-model="showStartTimePicker" position="bottom">
        <van-datetime-picker
          v-model="startPickerValue"
          type="datetime"
          title="选择开始时间"
          :min-date="minOrderDate"
          @confirm="onConfirmOrderStartTime"
          @cancel="showStartTimePicker = false"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        right-icon="clear"
        v-model="form.orderEndTime"
        label="订单结束时间"
        placeholder="请选择订单结束时间"
        @click="openEndTimePicker"
        @click-right-icon.stop="clearOrderEndTime"
      />
      <van-popup v-model="showEndTimePicker" position="bottom">
        <van-datetime-picker
          v-model="endPickerValue"
          type="datetime"
          title="选择结束时间"
          :min-date="minOrderDate"
          @confirm="onConfirmOrderEndTime"
          @cancel="showEndTimePicker = false"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        right-icon="clear"
        :value="platNameDisplay"
        label="平台"
        placeholder="请选择平台"
        @click="showPlatPicker = true"
        @click-right-icon.stop="clearPlatId"
      />
      <van-popup v-model="showPlatPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="platList"
          @confirm="onConfirmPlat"
          @cancel="showPlatPicker = false"
        />
      </van-popup>
      <div class="formBtn">
        <van-button
          round
          block
          type="info"
          size="small"
          @click="handleSearch()"
        >
          查询
        </van-button>
        <van-button
          round
          block
          type="info"
          size="small"
          @click="handleExport()"
        >
          导出
        </van-button>
        <img
          src="@/assets/img/dyCardBag/download.png"
          class="logo"
          @click="$router.push('/dyCardBag/reportDownloadList')"
        />
      </div>
    </van-form>
    <van-list
      class="container"
      :loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadData"
    >
      <div class="list">
        <div
          class="group"
          v-for="(item, index) in dyCardBagDetail"
          :key="item.id"
        >
          <div class="title">{{ item.goodsName || '—' }}</div>
          <div class="center">
            <!-- <div class="item">
              <div class="label">店铺:</div>
              <div class="value">
                {{ item.customerName }}
              </div>
            </div> -->
            <div class="item">
              <div class="label">第三方订单号:</div>
              <div class="value">
                {{ item.orderNo }}
              </div>
            </div>
            <div class="item">
              <div class="label">订单时间:</div>
              <div class="value">
                {{ item.orderTime }}
              </div>
            </div>
            <div class="item">
              <div class="label">发码时间:</div>
              <div class="value">
                {{ item.deliverTime }}
              </div>
            </div>
            <div class="item">
              <div class="label">有效期:</div>
              <div class="value">
                {{ item.expireTime }}
              </div>
            </div>
            <div class="item">
              <div class="label">券码类型:</div>
              <!-- codeType 0卡号卡密 1卡密 2卡号短链  3短链验证码  4兑换码 -->
              <div class="value">
                {{ getCodeTypeText(item.codeType) }}
              </div>
            </div>
            <div class="item" v-show="item.cardNo">
              <div class="label">卡号:</div>
              <div class="value">{{ item.cardNo }}</div>
              <div
                class="copy"
                v-clipboard:copy="item.cardNo"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <div class="item" v-show="item.cardPwd">
              <div class="label">卡密:</div>
              <div class="value">{{ item.cardPwd }}</div>
              <div
                class="copy"
                v-clipboard:copy="item.cardPwd"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <div class="item" v-show="item.verifyCode">
              <div class="label">验证码:</div>
              <div class="value">{{ item.verifyCode }}</div>
              <div
                class="copy"
                v-clipboard:copy="item.verifyCode"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <div class="item" v-show="item.shortUrl">
              <div class="label">短链:</div>
              <div class="value">{{ item.shortUrl }}</div>
              <div
                class="copy"
                v-clipboard:copy="item.shortUrl"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <div class="item" v-show="item.redeemCode">
              <div class="label">兑换码:</div>
              <div class="value">{{ item.redeemCode }}</div>
              <div
                class="copy"
                v-clipboard:copy="item.redeemCode"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError"
              >
                复制
              </div>
            </div>
            <!-- <div class="item">
              <div class="label">使用规则:</div>
              <div class="showRule" @click="showRule(index)">点击展示</div>
            </div> -->
            <div
              class="rule"
              v-show="index === showRuleIndex"
              v-html="item.useRule"
            />
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import moment from 'moment'
import { dyCardBagDetail, dyCardBagExport, listPlatInfo } from '@/api/dyCardBag'
export default {
  data() {
    return {
      loading: false,
      pageNum: 0,
      pageSize: 10,
      finished: false,
      dyCardBagDetail: [],
      showRuleIndex: null,
      form: {
        goodsName: undefined,
        orderStartTime: '',
        orderEndTime: '',
        platId: undefined
      },
      platList: [],
      showPlatPicker: false,
      showStartTimePicker: false,
      showEndTimePicker: false,
      startPickerValue: new Date(),
      endPickerValue: new Date(),
      minOrderDate: new Date(2023, 0, 1)
    }
  },
  computed: {
    platNameDisplay() {
      const option = this.platList.find(item => item.value === this.form.platId)
      return option ? option.text : ''
    }
  },
  created() {
    this.loadPlatList()
  },
  methods: {
    async loadPlatList() {
      try {
        const { data } = await listPlatInfo()
        this.platList = (data || []).map(item => ({
          text: item.platName,
          value: item.platId
        }))
      } catch (error) {
        console.log(error)
      }
    },
    async loadData(init) {
      try {
        if (!init) {
          this.pageNum++
        } else {
          // 第一页查询，清空数据
          this.dyCardBagDetail = []
          this.pageNum = 1
          this.finished = false
        }
        this.loading = true
        const param = this.form
        const { data } = await dyCardBagDetail({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          param: {
            goodsName: param.goodsName,
            startTime: param.orderStartTime || undefined,
            endTime: param.orderEndTime || undefined,
            platId: param.platId || undefined
          }
        })
        this.dyCardBagDetail.push(...data.records)
        if (this.dyCardBagDetail.length >= data.total) {
          this.finished = true
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        this.finished = true
        console.log(error)
      }
    },
    showRule(val) {
      if (val === this.showRuleIndex) {
        this.showRuleIndex = null
        return
      }
      this.showRuleIndex = val
    },
    copySuccess() {
      this.$toast({ message: '复制成功!' })
    },
    copyError() {
      this.$toast({ message: '复制失败!' })
    },
    formatDate(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    getCodeTypeText(codeType) {
      // <!-- codeType 0卡号卡密 1卡密 2卡号短链  3短链验证码  4兑换码 -->
      const typeMap = {
        0: '卡号卡密',
        1: '卡密',
        2: '卡号短链',
        3: '短链验证码',
        4: '兑换码'
      }
      return typeMap[codeType] || '—'
    },
    handleSearch() {
      this.loadData(1)
    },
    openStartTimePicker() {
      this.startPickerValue = this.form.orderStartTime
        ? moment(this.form.orderStartTime, 'YYYY-MM-DD HH:mm:ss').toDate()
        : new Date()
      this.showStartTimePicker = true
    },
    openEndTimePicker() {
      this.endPickerValue = this.form.orderEndTime
        ? moment(this.form.orderEndTime, 'YYYY-MM-DD HH:mm:ss').toDate()
        : new Date()
      this.showEndTimePicker = true
    },
    onConfirmOrderStartTime(value) {
      this.form.orderStartTime = moment(value).format('YYYY-MM-DD HH:mm:00')
      this.showStartTimePicker = false
    },
    onConfirmOrderEndTime(value) {
      this.form.orderEndTime = moment(value).format('YYYY-MM-DD HH:mm:59')
      this.showEndTimePicker = false
    },
    clearOrderStartTime() {
      this.form.orderStartTime = ''
    },
    clearOrderEndTime() {
      this.form.orderEndTime = ''
    },
    onConfirmPlat(option) {
      this.form.platId = option.value
      this.showPlatPicker = false
    },
    clearPlatId() {
      this.form.platId = undefined
    },
    async handleExport() {
      const param = this.form
      const { code, message } = await dyCardBagExport({
        goodsName: param.goodsName,
        startTime: param.orderStartTime || undefined,
        endTime: param.orderEndTime || undefined,
        platId: param.platId || undefined
      })
      if (code === 0) {
        this.$toast({ message: message })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  background: #ecedf0;
  padding: 250px 15px 32px;
  box-sizing: border-box;
  .group {
    margin: 0 0 8px;
    position: relative;
    background: #fff;
    border-radius: 15px;
    .title {
      font-weight: bold;
      font-size: 16px;
      color: #000000;
      line-height: 50px;
      text-align: center;
      border-bottom: dashed 1px #eaeaea;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0 10px;
      box-sizing: border-box;
    }
    .center {
      padding-top: 20px;
      box-sizing: border-box;
      .item {
        display: flex;
        align-items: center;
        padding: 0 20px 21px;
        font-size: 12px;
        width: 100%;
        &:last-child {
          padding-bottom: 0;
        }
        .label {
          color: #000000;
          width: 90px;
        }
        .value {
          flex: 1;
          width: 100%;
          color: #666666;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .copy {
          width: 48px;
          height: 24px;
          line-height: 24px;
          background: #1989fa;
          border-radius: 10px;
          font-size: 12px;
          color: #ffffff;
          text-align: center;
        }
        .showRule {
          color: #033cdc;
          text-align: right;
          flex: 1;
        }
      }
      .rule {
        background: #f3f3f5;
        border-radius: 10px;
        margin: 0 14px 0 16px;
        padding: 18px 32px 14px 13px;
        font-size: 12px;
        color: #666666;
        line-height: 20px;
      }
    }
  }
}
.form {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  width: 100%;
  background: #fff;
  z-index: 99;
  border-radius: 15px;
  box-shadow: 0px 4px 11px 0px rgba(178, 178, 178, 0.18);
}
.logo {
  position: fixed;
  right: 0;
  width: 80px;
  z-index: 999;
}
.formBtn {
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 50%;
  margin: 20px auto;
}
</style>
